export const baseUrl = `${process.env.REACT_APP_URL}/api/v1`